import request from '@/utils/request'

// 查询合同回款记录信息
export function queryContractFundRecordInfo(data) {
  return request({
    url: '/crmContractFundRecord/queryContractFundRecordInfo',
    method: 'post',
    data: data
  })
}

// 详情页查询回款记录列表
export function listContractFundRecord(query) {
  return request({
    url: '/crmContractFundRecord/listNoPage',
    method: 'get',
    params: query
  })
}

// 分页查询回款记录列表
export function listPageContractFundRecord(param) {
  return request({
    url: '/crmContractFundRecord/list',
    method: 'post',
    data: param
  })
}

// 按筛选条件导出全部回款记录（沿用列表数据权限）
export function exportContractFundRecord(param) {
  return request({
    url: '/crmContractFundRecord/export',
    method: 'post',
    data: param,
    responseType: 'blob',
    timeout: 60000
  })
}

// 查询回款记录详情
export function queryContractFundRecordDetail(query) {
  return request({
    url: '/crmContractFundRecord/detail',
    method: 'get',
    params: query
  })
}

// 新增回款记录
export function createContractFundRecord(data) {
  return request({
    url: '/crmContractFundRecord/create',
    method: 'post',
    data: data
  })
}

// 更新回款记录
export function updateContractFundRecord(data) {
  return request({
    url: '/crmContractFundRecord/update',
    method: 'post',
    data: data
  })
}

// 删除回款记录
export function delContractFundRecord(data) {
  return request({
    url: '/crmContractFundRecord/delete',
    method: 'post',
    data: data
  })
}



